import React, { useEffect } from "react";
import styled from "styled-components";
import { useSelector } from "react-redux";
import { RootState } from "../app/store";

const PageWrapper = styled.div`
  width: 100%;
  min-height: 100vh;
  padding: 20px;
  box-sizing: border-box;
  background: #000;
`;

const WidgetFrame = styled.iframe`
  width: 100%;
  height: calc(100vh - 40px);
  border: 0;
  display: block;
  border-radius: 12px;
  overflow: auto;
  background: #111;
`;

const OmegaJamAcademyPage: React.FC = () => {
  const user = useSelector((state: RootState) => state.authSlice.user);
  const token = localStorage.getItem("token");

  useEffect(() => {
    if (!token) return;

    const handleMessage = (event: MessageEvent) => {
      if (event.data && event.data.type === "REQUEST_JWT") {
        const latestToken = localStorage.getItem("token");

        if (event.source && latestToken) {
          const payload = {
            type: "DELIVER_JWT",
            token: latestToken,
            email: user?.email || "",
            username: user?.username || "",
          };

          console.log("Parent sending payload to iframe:", payload);

          (event.source as Window).postMessage(payload, event.origin);
        }
      }
    };

    window.addEventListener("message", handleMessage);

    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, [token, user]);

  if (!token) {
    return (
      <PageWrapper>
        <div style={{ color: "#fff", textAlign: "center", paddingTop: "40px" }}>
          Please login to access OmegaJam Academy.
        </div>
      </PageWrapper>
    );
  }

  return (
    <PageWrapper>
      <WidgetFrame
        src="https://omegajam.com/widget/Academy"
        title="OmegaJam Academy Widget"
        allow="fullscreen; clipboard-read; clipboard-write"
      />
    </PageWrapper>
  );
};

export default OmegaJamAcademyPage;